module.exports = __webpack_public_path__ + "assets/4164af21798ea476d0794b34dc35b519.mp3";